import fitty from 'fitty';

const selectors = {
  text: '[data-fitty-text]',
};

const settings = {
  small: {
    maxSize: 30,
  },
  large: {
    maxSize: 50,
  },
};

document.addEventListener('DOMContentLoaded', () => {
  const text = document.querySelectorAll(selectors.text);

  if (!text) return;

  text.forEach((element) => {
    const size = element.getAttribute('data-fitty-text');
    fitty(element, settings[size]);
  });
});
